import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function invoiceReducer(state = initialState.InvoiceDetail, action) {
    switch (action.type) {

        case types.GET_TENANT_INVOICE_DETAILS_SUCCESSFUL: 
        return {
            ...state,TenantInvoiceDetails: action.getResponse
        };

        case types.GET_TENANT_AFTERHOURS_DETAILS_SUCCESSFUL:
        return {
            ...state,TenantAfterHourDetails: action.getResponse
        };

        case types.GET_INOVICE_TEMPLATE:
        return {
            ...state,InvoiceTemplate: action.getResponse
        };

        case types.GET_FACILITY_IMAGE:
        return {
            ...state,FacilityImageDetail: action.getResponse
        };
        
        case types.GET_INOVICE_LOGO:
        return {
            ...state,Invoicelogo: action.getResponse  //returns image
        };

        case types.GET_FACILITY_BACKGROUND_IMAGE:
        return {
            ...state,FacilityImage: action.getResponse
        };

        case types.POST_INOVICE_IMAGE:
        return {
            ...state,PostInvoiceLogo: action.getResponse    //returns data
        };

        case types.GET_TENANT_GENERATED_INVOICES_SUCCESSFUL:
        return {
            ...state,GeneratedInvoiceList: action.getResponse
        };
        
        default : return state; 
    }   
}